import { render, staticRenderFns } from "./EnrollableScorm.vue?vue&type=template&id=6307a490&"
import script from "./EnrollableScorm.vue?vue&type=script&lang=js&"
export * from "./EnrollableScorm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports